<template>

	<li class="g-facet-set g-facet-set-bopis" :class="{'g-facet-set--collapsed': collapse}">
		<h3 class="g-facet-set__heading" @click="collapse = !collapse">
			<button class="g-facet-set__label g-button--no-styling">
				Need It Fast?
			</button>
		</h3>
		<div class="g-facet-set__list">
			<div class="g-facet-set__inner">
				<div v-if="storeAvailabilityFacet" class="g-facet-store-availability">
					<label class="g-facet-set__list-item g-form-checkbox">
						<input class="g-form-checkbox__input" v-model="storeAvailabilityFacet.facet_active" type="checkbox" @click="toggleFilter( storeAvailabilityFacet.field, selectedStore ? selectedStore.identifier : '' )" :disabled="!selectedStore || !selectedStore.name">
						<span class="g-facet-set__list-item-link g-form-checkbox__caption">
							<span class="g-facet-set__list-item-name">{{ storeAvailabilityFacet.label }}</span>
							<span class="g-facet-set__list-item-count" v-if="selectedStore && selectedStore.name">({{ storeAvailabilityFacetValue ? storeAvailabilityFacetValue.count : 0 }})</span>
						</span>
					</label>
					<div class="g-facet-store-availability-footer">
						<span v-if="selectedStore && selectedStore.name" class="g-facet-store-availability__name">{{selectedStore.name}}</span>
						<a href="#" @click.prevent="openModal()" class="g-facet-store-availability__trigger">{{ !selectedStore || !selectedStore.name ? 'Select Store' : 'Change Store' }}</a>
					</div>
				</div>
				<div v-if="bopisFacet" class="g-facet-bopis">
					<label class="g-facet-set__list-item g-form-checkbox" v-for="value in bopisFacet.values" :key="value.label">
						<input class="g-form-checkbox__input" v-model="value.active" type="checkbox" @click="toggleFilter( bopisFacet.field, value.type === 'value' ? value.value : [value.low, value.high] )">
						<span class="g-facet-set__list-item-link g-form-checkbox__caption">
							<span class="g-facet-set__list-item-name">{{ bopisFacet.label }}</span>
							<span class="g-facet-set__list-item-count">({{ value.count }})</span>
						</span>
					</label>
				</div>
			</div>
		</div>
	</li>

</template>

<script>

	import EventBus from '@mvps-genesis/event-bus';
import {BopisController} from 'custom-extensions/bopis';
import Search from '../../Search';

	export default {
		data() {
			return {
				uniqueId: '',
				collapse: false,
				controller: {},
				modal: null
			}
		},
		props: {
			facets: {
				default() {
					return [];
				}
			}
		},
		asyncComputed: {
			selectedStore() {
				if (this.storeAvailabilityFacetCurrentValue?.value) {
					if (this.storeAvailabilityFacetCurrentValue?.value === this.controller?.store?.state?.myStore?.identifier && this.controller?.store?.state?.myStore?.name) {
						return this.controller.store.state.myStore;
					}

					return this.getSelectedStore(this.storeAvailabilityFacetCurrentValue?.value);
				}

				if (this.controller?.store?.state?.myStore?.identifier && this.controller?.store?.state?.myStore?.name) {
					return this.controller.store.state.myStore;
				}

				return {};
			}
		},
		computed: {
			storeAvailabilityFacet() {
				const facets = this.facets.filter(filter => filter.field === 'current_store_inventory');
				return facets.length ? facets[0] : null;
			},
			storeAvailabilityFacetValue() {
				const facetValue = this.storeAvailabilityFacet?.values?.filter(filter => filter.value === this.selectedStore?.identifier);
				return facetValue.length ? facetValue[0] : null;
			},
			storeAvailabilityFacetCurrentValue () {
				const facetValue = this.storeAvailabilityFacet?.values?.filter(filter => filter.active);
				return facetValue.length ? facetValue[0] : null;
			},
			bopisFacet() {
				const facets = this.facets.filter(filter => filter.field === 'bopis');
				return facets.length ? facets[0] : null;
			}
		},
		methods: {
			toggleFilter ( field, value ) {

				Search.client.filter( field, value ).search();

			},
			shopStoreSelected () {

				if (!this.storeAvailabilityFacet?.facet_active) {
					return;
				}

				Search.client.filter( this.storeAvailabilityFacet.field, this.storeAvailabilityFacetCurrentValue.value );
				this.toggleFilter(this.storeAvailabilityFacet.field, this.selectedStore ? this.selectedStore.identifier : '');

			},
			openModal () {

				if (!this.modal) {
					return;
				}

				this.modal.open();

			},

			requestUpdate () {
				setTimeout(() => {
					this.$forceUpdate();
				}, 500);
			},

			async getSelectedStore (identifier) {
				const store = await this.controller?.api?.singleLocationLookup(identifier);
				return store;
			}
		},
		created() {

			this.uniqueId = this._uid;
			this.controller = BopisController;
			this.modal = document.getElementById('js-bopis-search');

			EventBus.addEventListener('MVPS:shopStoreSearchChanged', this.shopStoreSelected.bind(this), false);
			EventBus.addEventListener('MVPS:myStoreChanged', this.shopStoreSelected.bind(this), false);

		}
	}

</script>
